import React, { ComponentProps, ReactElement, ReactNode } from 'react';
import cn from 'classnames';
import {
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  TabsOrientation,
} from '@reach/tabs';

// @reach/polymorphic supports `as` at runtime but types restrict it to "button"
const PolyTab = Tab as React.FC<
  Omit<ComponentProps<typeof Tab>, 'as'> & { as?: React.ElementType }
>;

import '@reach/tabs/styles.css';

import styles from './VerticalTabs.module.scss';

export interface TabItem {
  tabContent: ReactNode | string;
  panelContent: ReactNode | string;
}

export interface VerticalTabsProps {
  items: TabItem[];
  classNames?: string | string[];
}

export const VerticalTabs = ({
  items,
  classNames,
}: VerticalTabsProps): ReactElement => {
  const className = cn(styles.tabsContainer, classNames);

  return (
    <Tabs orientation={TabsOrientation.Vertical} className={className}>
      <TabList className={styles.left}>
        {items.map(({ tabContent }) => (
          <PolyTab
            as="div"
            key={`VerticalTabs-${tabContent}`}
            className={styles.tab}
          >
            {tabContent}
          </PolyTab>
        ))}
      </TabList>
      <TabPanels className={styles.right}>
        {items.map(({ panelContent, tabContent }) => (
          <TabPanel key={`tabPanel-${tabContent}`} className={styles.pannel}>
            {panelContent}
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  );
};

export default VerticalTabs;
